import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=dd7e33b2&scoped=true"
import script from "./ContentBlock.js?vue&type=script&lang=js&external"
export * from "./ContentBlock.js?vue&type=script&lang=js&external"
import style0 from "./ContentBlock.scss?vue&type=style&index=0&id=dd7e33b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7e33b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
